/** 追加板Modelから共有表示層へ渡す、API originを含まない名前のsnapshot。 */
let names: Readonly<Record<string, string>> = Object.freeze(
  Object.create(null),
);
const listeners = new Set<() => void>();

export function getAddedBoardNames(): Readonly<Record<string, string>> {
  return names;
}

export function subscribeAddedBoardNames(listener: () => void): () => void {
  listeners.add(listener);
  return (): void => {
    listeners.delete(listener);
  };
}

/** 永続Modelの追加・解除・hydrateに表示名を追従させるアダプター。 */
export function syncAddedBoardNames(
  boards: readonly Readonly<{ slug: string; boardName: string }>[],
): void {
  names = Object.freeze(
    Object.assign(
      Object.create(null),
      Object.fromEntries(boards.map((board) => [board.slug, board.boardName])),
    ),
  );
  for (const listener of listeners) listener();
}
